// Node
import { createSlice } from '@reduxjs/toolkit'
// API
import { contactsAPI } from '../../api/endpoints/contactsAPI'
// Создатели действий загрузки
import { setLoading, setLoaded } from './load-reducer'

// Начальное состояние
const initialState = {
    // Текущий контакт
    currentContact: null,
    // Контакты
    contactsList: [],    
}

// Слайс контактов
const contactSlice = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        // Установить текущий контакт
        setCurrentContact(state, action) {                   
            state.currentContact = action.payload
        },
        // Установить список контактов
        setContactsList(state, action) {                   
            state.contactsList = action.payload
        },        
    }
})

// Экспорт создателей действий
export const { setCurrentContact, setContactsList } = contactSlice.actions;
// Экспорт редьюсера
export default contactSlice.reducer;

//THUNK CREATORS

// Получение контактов
export const getContactsList = () => {    
    return (dispatch) => {
        // Установить состояние загрузки в "Загружается"
        dispatch(setLoading('contact'))
                        
        // Получение данных через API контактов
        contactsAPI.getContactsList().then((response) => {                        
            // Установить полученную информацию
            dispatch(setContactsList(response))
            // Получение данных через API контактов
            contactsAPI.getContactItem(response[0]?.attributes?.id).then((subResponse) => {
                // Установить полученную информацию
                dispatch(setCurrentContact(subResponse))                
                // Установить состояние загрузки в "Загружено"
                dispatch(setLoaded('contact'))                
            })            
        })
    }
}